module.exports = __webpack_public_path__ + "static/img/Wealthbridge.b23fd099.jpeg";